import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "name", label: "Nome hotel / progetto", required: true },
  {
    key: "slug",
    label: "Slug (identificativo interno)",
    required: true,
    placeholder: "es. joy124",
  },
  { key: "before_img", label: "Foto PRIMA (edificio originale)", type: "image" },
  { key: "after_img", label: "Foto DOPO (hotel trasformato)", type: "image" },
  {
    key: "before_caption",
    label: "Didascalia PRIMA",
    textarea: true,
    rows: 2,
    placeholder: "Breve descrizione dell'edificio originale.",
  },
  {
    key: "after_caption",
    label: "Didascalia DOPO",
    textarea: true,
    rows: 2,
    placeholder: "Breve descrizione dopo la rigenerazione.",
  },
  { key: "order", label: "Ordine di visualizzazione", type: "number" },
  { key: "published", label: "Pubblicato sul sito", type: "checkbox" },
];

const INITIAL = {
  slug: "",
  name: "",
  before_img: "",
  after_img: "",
  before_caption: "",
  after_caption: "",
  order: 999,
  published: true,
};

export default function AdminBeforeAfter() {
  const [items, setItems] = useState([]);

  const load = () =>
    adminApi.get("/admin/before-after").then((r) => setItems(r.data));

  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="Prima / Dopo"
      subtitle="Galleria rigenerazione urbana: confronta le foto dell'edificio originale con la trasformazione finale."
      endpoint="/admin/before-after"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      imageField="after_img"
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg">{item.name}</div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            ordine {item.order}
            {item.published === false && (
              <span className="ml-3 text-red-400">BOZZA</span>
            )}
          </div>
        </div>
      )}
    />
  );
}
